import React from 'react';

const LiveIcon = () => (
  <svg className='live-icon' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 10C0 4.47715 4.47715 0 10 0H39C40.1046 0 41 0.895431 41 2V38C41 39.1046 40.1046 40 39 40H2C0.895431 40 0 39.1046 0 38V10Z'
      fill='#081E58'
    />
    <path
      d='M29.1571 3.32844C28.7191 2.89052 28.0236 2.89052 27.5857 3.32844C27.1478 3.76637 27.1478 4.4619 27.5857 4.89982C31.5012 8.81538 31.5012 15.1782 27.5857 19.0937C27.1478 19.5317 27.1478 20.2272 27.5857 20.6651C27.7918 20.8712 28.0751 21 28.3585 21C28.6418 21 28.9252 20.897 29.1313 20.6651C33.9227 15.8737 33.9227 8.0941 29.1571 3.32844Z'
      fill='#0D47D9'
    />
    <path
      d='M25.4733 6.9864C25.0354 6.54848 24.3399 6.54848 23.902 6.9864C23.464 7.42433 23.464 8.11986 23.902 8.55778C25.7825 10.4383 25.8082 13.5295 23.902 15.41C23.464 15.8479 23.464 16.5435 23.902 16.9814C24.108 17.1875 24.3914 17.3163 24.6748 17.3163C24.9581 17.3163 25.2415 17.2132 25.4476 16.9814C28.2554 14.225 28.2297 9.74275 25.4733 6.9864Z'
      fill='#0D47D9'
    />
    <path
      d='M13.4175 4.89982C13.8555 4.4619 13.8555 3.76637 13.4175 3.32844C12.9796 2.89052 12.2841 2.89052 11.8462 3.32844C7.0805 8.0941 7.0805 15.8737 11.8462 20.6394C12.0522 20.8454 12.3356 20.9742 12.619 20.9742C12.9023 20.9742 13.1857 20.8712 13.3918 20.6394C13.8297 20.2014 13.8297 19.5059 13.3918 19.068C9.50197 15.1782 9.50197 8.81538 13.4175 4.89982Z'
      fill='#0D47D9'
    />
    <path
      d='M17.0755 8.55778C17.5134 8.11986 17.5134 7.42433 17.0755 6.9864C16.6376 6.54848 15.942 6.54848 15.5041 6.9864C12.7478 9.74275 12.7478 14.225 15.5041 16.9814C15.7102 17.1875 15.9936 17.3163 16.2769 17.3163C16.5603 17.3163 16.8437 17.2132 17.0497 16.9814C17.4877 16.5435 17.4877 15.8479 17.0497 15.41C15.195 13.5295 15.195 10.4383 17.0755 8.55778Z'
      fill='#0D47D9'
    />
    <path
      d='M20.5016 13.8644C21.5402 13.8644 22.3821 13.0225 22.3821 11.9839C22.3821 10.9453 21.5402 10.1034 20.5016 10.1034C19.463 10.1034 18.6211 10.9453 18.6211 11.9839C18.6211 13.0225 19.463 13.8644 20.5016 13.8644Z'
      fill='#E60053'
    />
    <path
      d='M6.83191 28.432V37H12.8919V35.416H8.71591V28.432H6.83191ZM14.9452 28.432V37H16.8292V28.432H14.9452ZM23.4683 37L26.3123 28.432H24.3683L22.4363 34.456H22.4123L20.5043 28.432H18.5722L21.3443 37H23.4683ZM28.0428 28.432V37H34.5468V35.416H29.9268V33.316H34.0788V31.852H29.9268V30.016H34.4508V28.432H28.0428Z'
      fill='white'
    />
  </svg>
);

export default LiveIcon;
